// src/components/Toaster/toasterActions.js

export const TOASTER_SHOW = "TOASTER_SHOW";
export const TOASTER_HIDE = "TOASTER_HIDE";

export const showToaster = (heading, message, variant = "success") => ({
    type: TOASTER_SHOW,
    payload: { heading, message, variant },
});

export const hideToaster = () => ({
    type: TOASTER_HIDE,
});



// WEBPACK FOOTER //
// ./src/components/Toaster/toasterActions.js